import React from 'react'
import './styles.css' // Import the CSS file for styling
import FixWidthContainer from '../../atoms/fixWidthContainer'
import { Carousel } from 'react-responsive-carousel'
import Spacer from '../../atoms/Spacer'
import carrousel from '../../../assets/img/about.png'
import carrousel1 from '../../../assets/img/carrousel1.jpg'
import carrousel2 from '../../../assets/img/carrousel2.jpg'
import carrousel3 from '../../../assets/img/carrousel3.jpg'
import carrousel4 from '../../../assets/img/carrousel4.jpg'
import carrousel5 from '../../../assets/img/carrousel5.jpg'
import carrousel6 from '../../../assets/img/carrousel6.jpg'
import about1 from '../../../assets/img/about1.png'
import about2 from '../../../assets/img/about2.png'
import about3 from '../../../assets/img/about3.png'
import about4 from '../../../assets/img/about4.png'

import CallToAction from '../../atoms/callToAction'

const About = () => {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }
  }, [])

  return (
    <div>
      <Spacer size={isMobile ? 0 : 140} />
      <FixWidthContainer justifyContent="flex-start" alignItems="flex-start">
        <div className="about-section">
          <Carousel
            height={300}
            width={isMobile ? 360 : 400}
            autoPlay
            interval={4000}
            infiniteLoop
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
            stopOnHover={false}
          >
            <div>
              <img
                src={carrousel}
                alt="about"
                style={{ height: 300, borderRadius: 20 }}
              />
            </div>
            <div>
              <img
                src={carrousel1}
                alt="about1"
                style={{ height: 300, borderRadius: 20 }}
              />
            </div>
            <div>
              <img
                src={carrousel2}
                alt="about2"
                style={{ height: 300, borderRadius: 20 }}
              />
            </div>
            <div>
              <img
                src={carrousel3}
                alt="about3"
                style={{ height: 300, borderRadius: 20 }}
              />
            </div>
          </Carousel>
          <div className="about-info">
            <h2>Conheça o consultório</h2>
            <div className="about-text">
              <img
                src={about3}
                style={{ height: 20, width: 17, marginLeft: 5 }}
                alt="about3"
              />
              <p> Localização central;</p>
            </div>
            <div className="about-text">
              <img
                src={about2}
                style={{ height: 20, width: 25 }}
                alt="about2"
              />
              <p>
                Rua plana, tranquila, disponibilidade de vagas na rua sem
                rotativo;
              </p>
            </div>
            <div className="about-text">
              <img
                src={about4}
                style={{ height: 25, width: 25 }}
                alt="about4"
              />
              <p>Sala de espera ampla, arejada e confortável;</p>
            </div>
            <div className="about-text">
              <img
                src={about1}
                style={{ height: 25, width: 25 }}
                alt="about1"
              />
              <p>
                Consultório lúdico, espaçoso com brinquedos atraentes às
                diferentes faixas etárias.
              </p>
            </div>
            <CallToAction className="test">Agendar Consulta</CallToAction>
          </div>
        </div>
      </FixWidthContainer>
    </div>
  )
}

export default About
